import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useRef } from "react";
import { Input } from "components/bootstrap";
import { IconButton } from "components/common";
import FilterEditButton from "views/components/widgets/overview-configuration/filters/FilterEditButton";
import UnknownAttributeTitle from "views/components/widgets/events/UnknownAttributeTitle";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const FilterValue = styled.div`
  display: flex;
  justify-content: space-between;
`;
const ValueTitle = styled.div`
  padding-top: 5px;
`;
const ValueActions = styled.div`
  margin-top: 2px;
`;
const SelectedFiltersList = ({ selectedFilters, columnTitle, filterComponents, onDelete, onEdit }) => {
  const { t } = useTranslation("widgets");
  const container = useRef(null);
  return /* @__PURE__ */ React.createElement(Container, { ref: container }, selectedFilters.toArray().map(({ field: column, value: values }, filterIndex) => {
    const _columnTitle = columnTitle(column);
    const filterComponent = filterComponents.find(({ attribute }) => attribute === column);
    return /* @__PURE__ */ React.createElement(FilterContainer, { key: column }, /* @__PURE__ */ React.createElement(
      Input,
      {
        id: `${column}-filter-configuration`,
        label: _columnTitle === "unknown" ? /* @__PURE__ */ React.createElement(UnknownAttributeTitle, null) : _columnTitle,
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      },
      values.map((value, valueIndex) => {
        var _a, _b, _c;
        const _onEdit = (newValue) => {
          onEdit(filterIndex, valueIndex, newValue);
        };
        return /* @__PURE__ */ React.createElement(FilterValue, { key: value }, /* @__PURE__ */ React.createElement(ValueTitle, null, filterComponent ? (_b = (_a = filterComponent.renderValue) == null ? void 0 : _a.call(filterComponent, value)) != null ? _b : value : ""), /* @__PURE__ */ React.createElement(ValueActions, null, filterComponent && /* @__PURE__ */ React.createElement(
          FilterEditButton,
          {
            filterComponent,
            onEdit: _onEdit,
            onDelete: () => onDelete(filterIndex, value),
            selectedValues: values,
            columnTitle,
            containerWidth: (_c = container.current) == null ? void 0 : _c.offsetWidth,
            column,
            value
          }
        ), /* @__PURE__ */ React.createElement(
          IconButton,
          {
            name: "delete",
            onClick: () => onDelete(filterIndex, value),
            title: t("overview_configuration.delete_filter", { column: _columnTitle })
          }
        )));
      })
    ));
  }));
};
export default SelectedFiltersList;
